import './OrderCartItem.css';
import { StringOrNothingFormater, getArticleOrSysId, parsePrice } from '../../../../../assets/utils/utils';


function OrderCartItem({
    item,
    amount,
    price,
    totalPrice,
    discount,
    onMinus,
    onPlus,
    isEditing,
    minimalValue,
    maxAmount,
    isChanged,
    isRemoved,
}) {
    const imageUrl = item?.item?.files?.[0]?.urls?.orig;
    const options = item?.options || [];

    return (
        <div
            className={`order-cart-item ${isEditing ? 'order-cart-item_edit' : ''} ${isChanged ? 'order-cart-item_changed' : ''} ${isRemoved ? 'order-cart-item_removed' : ''}`}
        >
            <div className="order-cart-item__preview">
                {imageUrl ? (
                    <img src={imageUrl} alt="" className="order-cart-item__img" />
                ) : (
                    <div className="order-cart-item__img order-cart-item__img_placeholder" />
                )}
            </div>

            <div className="order-cart-item__content">
                <div className="order-cart-item__head">
                    <div className="order-cart-item__titles">
                        <p className="order-cart-item__name">
                            {StringOrNothingFormater(item?.item?.name)}
                        </p>
                        <p className="order-cart-item__meta">
                            {getArticleOrSysId(
                                item?.item?.parameters || item?.item?.params || [],
                                item?.item?.unique_id || '—',
                            )}
                        </p>
                        {options.length > 0 ? (
                            <div className="order-cart-item__options">
                                {options.map((option, idx) => (
                                    <span
                                        className="order-cart-item__option"
                                        key={`${item._id}-option-${idx}`}
                                    >
                                        {option.name}: {option.value}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                    </div>

                    <div className="order-cart-item__price-block">
                        <div className="order-cart-item__price-line">
                            <span className="order-cart-item__price">
                                {amount} x {price ? parsePrice(price, 'RUB') : '—'}
                            </span>
                            {discount ? (
                                <span className="order-cart-item__badge">-{discount}%</span>
                            ) : null}
                        </div>
                        <span className="order-cart-item__total">
                            {parsePrice(totalPrice, 'RUB')}
                        </span>
                    </div>
                </div>

                {isEditing ? (
                    <div className="order-cart-item__controls">
                        <button
                            type="button"
                            className={`order-cart-item__btn ${Number(amount) === minimalValue ? 'order-cart-item__btn_disabled' : ''}`}
                            onClick={onMinus}
                            disabled={Number(amount) === minimalValue}
                        >
                            −
                        </button>
                        <span className="order-cart-item__amount">
                            {amount}
                        </span>
                        <button
                            type="button"
                            className={`order-cart-item__btn ${Number(amount) === maxAmount ? 'order-cart-item__btn_disabled' : ''}`}
                            onClick={onPlus}
                            disabled={Number(amount) === maxAmount}
                        >
                            +
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default OrderCartItem;
